import React from "react";

const AfishaSearchEvents = ({
  clientWidth,
  onSearchBtnClick,
  onInputChange,
  onEnterKeyPress,
  query
}) => {
  return (
    <div
      className="afisha-search_input"
      style={
        clientWidth ? { marginBottom: "10px", position: "relative" } : null
      }
    >
      <input
        onChange={e => onInputChange(e)}
        onKeyPress={e => onEnterKeyPress(e)}
        value={query}
        type="text"
        placeholder={
          !clientWidth
            ? "Введите название мероприятия, библиотеку, станцию метро или район"
            : null
        }
      />
      {!clientWidth ? (
        <button onClick={() => onSearchBtnClick()}>Найти</button>
      ) : (
        <svg
          onClick={() => onSearchBtnClick()}
          style={{
            position: "absolute",
            right: "10px",
            textAlign: "center",
            top: "calc(50% - 20px / 2)"
          }}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2857 12.5714H13.3714L13.0286 12.2286C14.1714 10.9714 14.8571 9.25714 14.8571 7.42857C14.8571 3.31429 11.5429 0 7.42857 0C3.31429 0 0 3.31429 0 7.42857C0 11.5429 3.31429 14.8571 7.42857 14.8571C9.25714 14.8571 10.9714 14.1714 12.2286 13.0286L12.5714 13.3714V14.2857L18.2857 20L20 18.2857L14.2857 12.5714ZM7.4283 12.5713C4.57116 12.5713 2.28545 10.2856 2.28545 7.42848C2.28545 4.57134 4.57116 2.28562 7.4283 2.28562C10.2854 2.28562 12.5712 4.57134 12.5712 7.42848C12.5712 10.2856 10.2854 12.5713 7.4283 12.5713Z"
            fill="#2B2B2B"
          />
        </svg>
      )}
    </div>
  );
};

export default AfishaSearchEvents;



// WEBPACK FOOTER //
// ./src/components/Events/AfishaSearchEvents.js